<template>
  <div :class="classCompute">{{ display }}</div>
</template>

<script lang="ts">
export default {
  name: 'Badge',
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    badgeContent: {
      type: Number || String,
      required: true,
    },
  },
  computed: {
    display(): String {
      if (typeof this.badgeContent === 'string') return this.badgeContent;
      const numberString = this.badgeContent.toString();
      if (!Number.isInteger(this.badgeContent)) return '';
      if (this.badgeContent < 1) {
        return '0';
      }
      if (this.badgeContent < 100) {
        return numberString;
      }
      return '99+';
    },
    classCompute(): String[] {
      const variantClasses = {
        primary: 'badge-primary',
        subdued: 'badge-subdued',
        strong: 'badge-strong',
        moderate: 'badge-moderate',
      };
      const widthClass = this.badgeContent > 99 ? 'wide' : null;
      return ['badge', variantClasses[this.variant], widthClass];
    },
  },
};
</script>

<style scoped lang="scss">
.badge {
  text-align: center;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 50px;
  max-width: max-content;
  line-height: 19px;
  font-size: 12px;
  white-space: nowrap;
}

.badge-primary {
  background-color: theme('colors.primary.DEFAULT');
  color: theme('colors.primary.subdued');
}

.badge-subdued {
  background-color: theme('colors.primary.subdued');
  color: theme('colors.primary.DEFAULT');
}

.badge-strong {
  background-color: #b84d8d;
  color: theme('colors.white');
}

.badge-moderate {
  background-color: #ebccde;
  color: theme('colors.primary.DEFAULT');
}
</style>
